import React from 'react';
import withIcon from '../utilities/withIcon';

const IconUnlock = () => {
  return (
    <g>
      <path d="m12.3184.2507a3.7 3.7 0 0 0 -3.6514 3.4014v2.7437h-7.8711a.75.75 0 0 0 -.75.75v7.8535a.75.75 0 0 0 .75.75h11.4541a.75.75 0 0 0 .75-.75v-7.8535a.75.75 0 0 0 -.75-.75h-2.083v-2.7437a2.1594 2.1594 0 0 1 4.2871-.0068v3.5a.75.75 0 0 0 1.5 0v-3.5a3.6882 3.6882 0 0 0 -3.6357-3.3946zm-.8184 13.9986h-9.9541v-6.3535h9.9541z" />
      <path d="m6.5234 9.05a.75.75 0 0 0 -.75.75v2.545a.75.75 0 0 0 1.5 0v-2.545a.75.75 0 0 0 -.75-.75z" />
    </g>
  );
};

export default withIcon(IconUnlock);
